/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const TIMER_VAR_NAME = feature.getSettingValue('TIMER_NAME');
    const TIMER_NAME = `timer_${feature.getSettingValue('TIMER_NAME')}`;

    blocks.push({
        location: 'GLOBAL_DIMS',
        blockType: BlockType.CODE,
        // template: `dim ${VARNAME} as ${DATATYPE}=${defaultValue}`,
        template: `
dim ${TIMER_NAME} as dword=0
dim ${TIMER_NAME}_CURRENT_MS as dword=0
dim ${TIMER_NAME}_repeat as boolean=false
`,
    });

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
declare ${TIMER_NAME} as dword
declare ${TIMER_NAME}_repeat as boolean=false
declare ${TIMER_NAME}_CURRENT_MS as dword=0
declare sub ${TIMER_NAME}_update()`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        template: `
sub ${TIMER_NAME}_update()
    if ${TIMER_NAME}<>0 then
        'if ${TIMER_NAME}=0 then
        '    ${TIMER_NAME}=sys.timercountms+${TIMER_VAR_NAME}*1000
        'end if
        dim timercountms as dword=sys.timercountms
        if timercountms<${TIMER_NAME} then
            dim remainder as dword=${TIMER_NAME}-timercountms
            remainder=remainder/1000
            if remainder=0 then
                remainder=1
            end if
            var_${TIMER_VAR_NAME}_update_completed(remainder)
        else
            var_${TIMER_VAR_NAME}_set(0)
            ${TIMER_NAME}=0
            '****${TIMER_NAME}_update****'
            if ${TIMER_NAME}_repeat then
                ${TIMER_NAME}=sys.timercountms+${TIMER_NAME}_CURRENT_MS
                ${TIMER_VAR_NAME}=${TIMER_NAME}_CURRENT_MS / 1000
                if ${TIMER_VAR_NAME} = 0 AND ${TIMER_VAR_NAME} > 0 then
                    ${TIMER_VAR_NAME} = 1
                end if
            end if
        end if
        
    end if
    
end sub`,
    });

    blocks.push({
        location: `var_${TIMER_VAR_NAME}_set`,
        blockType: BlockType.CODE,
        template: `
${TIMER_NAME} = sys.timercountms + ${TIMER_VAR_NAME} * 1000
        `,
    });

    blocks.push({
        location: 'on_sys_timer',
        blockType: BlockType.CODE,
        template: `
${TIMER_NAME}_update()`,
    });

    return blocks;
};
